import produce from "immer";

import { AWARDS_WATCH_ON, AWARDS_WATCH_OFF } from "../actions/types";

const initialState = {
  dbSync: false
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case AWARDS_WATCH_ON:
        draft = { dbSync: true, ...action.payload };
        return draft;
      case AWARDS_WATCH_OFF:
        draft = initialState;
        return draft;
    }
  });
};
